export const HeroBanner = ({ settings }) => {
  const heroImage = settings?.hero_image_url;
  const heroVideo = settings?.hero_video_url;

  if (!heroImage && !heroVideo) return null;

  return (
    <section data-testid="hero-section" className="pb-2 relative z-10">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-12">
        <div className="relative aspect-[16/9] lg:aspect-[128/50] w-full overflow-hidden rounded-md">
          {heroVideo ? (
            <video
              src={heroVideo}
              autoPlay
              muted
              loop
              playsInline
              className="w-full h-full object-cover"
            />
          ) : (
            <img src={heroImage} alt="RROV Goa" className="w-full h-full object-cover" />
          )}
        </div>
      </div>
    </section>
  );
};
